exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.thead-default-back {\r\n  background-color: #171514;\r\n  color: #dbdbdb;\r\n}\r\n\r\n.table-body {\r\n  background-color: #ffffff;\r\n}\r\n\r\n.no-link {\r\n  padding: 15px;\r\n  color: #124a78 !important;\r\n  font-weight: bold;\r\n  text-decoration: none;\r\n}\r\n\r\n.no-link:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.th-title {\r\n  padding-left: 30px;\r\n}\r\n\r\n.not-color {\r\n  color: #838383;\r\n}\r\n\r\n.small-text {\r\n  font-size: small;\r\n}\r\n\r\n/*\r\nGeneric Styling, for Desktops/Laptops\r\n*/\r\ntable {\r\n  width: 100%;\r\n  background-color: white;\r\n}\r\n\r\nth {\r\n  background: #343434;\r\n  color: white;\r\n  font-weight: bold;\r\n}\r\n\r\ntd, th {\r\n  padding: 6px;\r\n  text-align: left;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/company-structure/company-structure.component.css
// module id = ../../../../../src/app/content-page/company-structure/company-structure.component.css
// module chunks = main